
import React from 'react';
import { Link } from 'react-router-dom';
import { Clock } from 'lucide-react';

interface BlogPostProps {
  post: {
    id: string | number;
    title: string;
    excerpt: string;
    author: string;
    date: string;
    readTime: string;
    slug: string;
    tags?: string[];
    groupId?: string;
    groupName?: string;
    content?: string; // Add content field
    image?: string; // Add image field
  }
}

const BlogPostCard: React.FC<BlogPostProps> = ({ post }) => {
  return (
    <div className="product-card bg-white dark:bg-gray-800 rounded-lg overflow-hidden border border-gray-100 dark:border-gray-700">
      <Link to={`/blog/${post.slug}/${post.id}`}>
        {post.image && (
          <div className="aspect-video w-full overflow-hidden">
            <img 
              src={post.image} 
              alt={post.title}
              className="w-full h-full object-cover transition-transform hover:scale-105"
            />
          </div>
        )}
        <div className="p-6">
          <div className="flex items-center mb-3 text-sm">
            <span className="text-gray-500 dark:text-gray-400">{post.date}</span>
            <span className="mx-2">•</span>
            <span className="flex items-center text-gray-500 dark:text-gray-400">
              <Clock size={14} className="mr-1" />
              {post.readTime}
            </span>
          </div>
          
          <h3 className="font-semibold text-lg mb-3 hover:text-primary transition-colors">
            {post.title}
          </h3>
          
          <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
            {post.excerpt}
          </p>
          
          {post.tags && post.tags.length > 0 && (
            <div className="flex flex-wrap gap-2 mb-4">
              {post.tags.map((tag, index) => (
                <span key={index} className="card-badge">
                  {tag}
                </span>
              ))}
            </div>
          )}
          
          <div className="flex items-center mt-2">
            <div className="w-8 h-8 rounded-full bg-gray-300 flex items-center justify-center mr-3">
              <span className="font-medium text-xs text-gray-600">
                {post.author.split(' ').map(name => name[0]).join('')}
              </span>
            </div>
            <span className="text-sm font-medium">{post.author}</span>
          </div>
        </div>
      </Link>
    </div>
  );
};

export default BlogPostCard;
